import React, {createContext, useReducer} from 'react';
import viewReducer from '../reducers/viewReducer.js';

const defaultView = {
	selectedView: 'Map',
	selectedCity: 'Portsmouth',
	mapView: 'props',
	mapFilterProps: 'roughness',
	mapFilterIndices: 'inclusion',
};

export const ViewContext = createContext();

export function ViewProvider(props) {
	const [view, dispatch] = useReducer(viewReducer, defaultView);

	return <ViewContext.Provider value={{view, dispatch}}>{props.children}</ViewContext.Provider>;
}
